<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="fm-title">Publisher’s Note</p>
<p class="fm-title1">PROTECTING OUR COLLECTIVE FUTURE</p>
<p class="noindent1">One of the books I am most proud to publish is this essential parenting book by the wise and wonderful Marita Golden. Parenting is hard work; you have to raise your child and teach them how to succeed as an independent adult. This is simply not enough for parents of Black sons in America; you must also prepare them to face racial inequity of all kinds. They need to know how to navigate a world where the odds are so often stacked against them, from microaggressions at school to macroaggressions that can end with a gun aimed at you during a routine traffic stop. While society is working toward a level playing field for Black families, we have a long way to go. That is why I am honored to have worked on Golden’s book, which faces these problems head-on and offers helpful information, tough and honest talk, and an abundance of resources for kids and parents. In this new edition, the incredible M.J. Fievre offers her wisdom on preparing your Black sons to survive and thrive in her afterword that includes “The Talk” and many more vital tips and suggestions. As the author of <i>Raising Confident Black Kids</i>, M.J. offers so much to Black families. Perhaps the most important thing about this book is that it offers tools and, while realistic, is never hopeless but hews toward that better future.</p>
<p class="noindent1">We would love to hear from you too, and I invite you to contact me directly at my email below. I hope this book helps you on your journey, and I wish you all the best and a life filled with awesomeness.</p>
<p class="righta">Be well,<br/>Brenda Knight</p>
<p class="right">Publisher, Mango Publishing Group<br/><a href="mailto://Brenda@MangoPublishingGroup.com" target="_blank">Brenda@MangoPublishingGroup.com</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm2.vue?c37f4012